// Pubnub
export const PUBNUB_PUBLISH_KEY = import.meta.env.VITE_PUBNUB_PUBLISH_KEY
export const PUBNUB_SUBSCRIBE_KEY = import.meta.env.VITE_PUBNUB_SUBSCRIBE_KEY
export const BASE_URL = import.meta.env.VITE_BASE_URL
export const APP_ENV = import.meta.env.VITE_APP_ENV || 'dev'

export const SERVICE_VERSION = import.meta.env.VITE_SERVICE_VERSION

export const DATADOG_APPLICATION_ID = import.meta.env.VITE_DATADOG_APPLICATION_ID
export const DATADOG_CLIENT_TOKEN = import.meta.env.VITE_DATADOG_CLIENT_TOKEN
export const DATADOG_ENABLED = import.meta.env.VITE_DATADOG_ENABLED === 'true'

// We only have 2 environments for the members web app
export const membersWebAppUrl =
  process.env.NODE_ENV == 'production'
    ? 'https://members.firefly.health'
    : 'https://dev.members.firefly.health'
